jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */

	 function addQuoteList(item, qty){
		var requestData = [];
		var storedData = localStorage.getItem('requestData');
		if (storedData) {
		requestData = JSON.parse(storedData);
		}
		var varId = $(item).data('var_id');
		var title = $(item).data('product_title');
		var img = $(item).data('product_img');
		
		var existingObject = requestData.find(obj => obj.varId === varId);
		if (existingObject) {
		existingObject.title = title;
		existingObject.qty = parseInt(existingObject.qty) + parseInt(qty);
		} else {
		requestData.push({ varId: varId, title: title, qty: qty, img: img });
		}
		localStorage.setItem('requestData', JSON.stringify(requestData));
		console.log('Updated request data:', requestData);
	 }

	 function updateQuoteList(item, qty){
		var requestData = [];
		var storedData = localStorage.getItem('requestData');
		if (storedData) {
		requestData = JSON.parse(storedData);
		}
		var varId = $(item).data('var_id');
		var title = $(item).data('product_title');
		var img = $(item).data('product_img');
		
		var existingObject = requestData.find(obj => obj.varId === varId);
		if (existingObject) {
		existingObject.title = title;
		existingObject.qty = parseInt(qty);
		} else {
		requestData.push({ varId: varId, title: title, qty: qty, img: img });
		}
		localStorage.setItem('requestData', JSON.stringify(requestData));
		console.log('Updated request data:', requestData);
		creatList();
	 }
	 $('.add-request-quote-button').click(function(event) {
		event.preventDefault();
		var item =$(this);
		var qty = $('.t4s-quantity-input').val();
		addQuoteList(item, qty);
		window.location.href='/pages/request-quote';
	});

	function creatList(){

    // Load data from localStorage if available
    var requestData = localStorage.getItem('requestData');
	
    if (requestData) {
	
      var requestData = JSON.parse(requestData);

      // Get the tbody element
      var cartItems = $('#requestDate');
	  cartItems.html('');
	  if (requestData.length === 0) {
		$('.shop_table_responsive').hide();
		$('.empty-quote').show();
	  }else{
		$('.shop_table_responsive').show();
		$('.empty-quote').hide();
	  }
      // Loop through the cart data and create cart items
      requestData.forEach(function(item, index) {
		console.log(item);
		var cartItemHtml = `
        <tr class="cart_item">
		<input
		value="Product Title: ${item.title}, Product Quantity: ${item.qty}"
		type="hidden"
		name="contact[item${index}]">

		<td class="product-remove">
		 <a href="#"  data-var_id="${item.varId}" class="remove-item remove" title="Remove this item">×</a>
		</td>
          <td class="product-thumbnail">
            <span><img src="${item.img}" ></span>
          </td>
          <td class="product-name" data-title="Product">
            <span>${item.title}</span>
          </td>
          <td class="product-quantity" data-title="Quantity">
		  <div class="quantity buttons_added">
          <input type="button" value="-" class="minus button is-form">
          <input type="number" data-product_title="${item.title}"  data-product_img="${item.img}" data-var_id="${item.varId}" id="quantity_${item.varId}" class="input-text qty text" name="raq[${item.varId}][qty]" value="${item.qty}" title="Qty" size="4" min="1" step="1" inputmode="numeric" autocomplete="off">
          <input type="button" value="+" class="plus button is-form" >
        </div>
          </td>
        </tr>
      `;
      cartItems.append(cartItemHtml);
    });
}
	}

    // Plus and minus button functionality
    $(document).on('click', '.plus, .minus', function() {
		var input = $(this).siblings('input[type="number"]');
		var currentValue = parseInt(input.val());
		
		if ($(this).hasClass('plus')) {
		  input.val(currentValue + 1);
		  var qty = input.val();
		  updateQuoteList(input, qty);
		} else {
		  if (currentValue > 1) {
			input.val(currentValue - 1);
			var qty = input.val();
		    updateQuoteList(input, qty);
		  }
		}
	  });

	  $(document).on('click', '.remove-item', function(event) {
		event.preventDefault();
		var varIdToRemove = $(this).data('var_id');
		var requestData = localStorage.getItem('requestData');
		$(this).parents('.cart_item').hide();
		  var requestData = JSON.parse(requestData);
		  requestData = requestData.filter(item => item.varId !== varIdToRemove);

		  localStorage.setItem('requestData', JSON.stringify(requestData));
		  creatList();
		  if (requestData.length === 0) {
			$('.shop_table_responsive').hide();
			$('.empty-quote').show();
		  }else{
			$('.shop_table_responsive').show();
			$('.empty-quote').hide();
		  }
		  
	  });



	  creatList();

});